import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './styles.scss';


const ButtonText = (props) => {
  let {className, ...otherProps} = props;
  className = classNames("ov-btn-text", className);

  return (
    <span className={className} {...otherProps}>{props.children}</span>
  );
}


const Button = (props) => {
  const className = classNames("ov-btn", props.className);

  // Need to unset props by ourselves if disabled since we're using <a> element
  let { href, target, onClick, disabled } = props;
  if (disabled) {
    href = "";
    target = "";
    onClick = ()=>{};
  }

  if (href) {
    return (
      <a href={href} target={target} className={className} onClick={onClick} role="button">
        {props.text}{props.children}
      </a>
    );
  }

  return (
    <a className={className} onClick={onClick} disabled={disabled} role="button">{props.text}{props.children}</a>
  );
}


Button.propTypes = {
  text: PropTypes.string,
  href: PropTypes.string,
  target: PropTypes.string,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func
};

Button.defaultProps = {
  text: '',
  href: "",
  target: "",
  className: '',
  disabled: false,
  onClick: ()=>{}
};



Button.Text = ButtonText;
export { Button };
